import React from "react";

/* eslint-disable max-len */
export default function SlideButton() {
    return (
        <svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 83.1 24.2" enableBackground="new 0 0 83.1 24.2" xmlSpace="preserve">
		<path fill="#FFFFFF" stroke="#676767" strokeWidth="1.0124" strokeMiterlimit="10" d="M79.5,23.6h-76c-1.7,0-3-1.3-3-3v-17
			c0-1.7,1.3-3,3-3h76c1.7,0,3,1.3,3,3v17C82.5,22.2,81.2,23.6,79.5,23.6z"/>
		<path fill="#676767" d="M15.1,3.9H8.5c-0.9,0-1.6,0.7-1.6,1.6l0,13.1c0,0.9,0.7,1.6,1.6,1.6h9.8c0.9,0,1.6-0.7,1.6-1.6V8.8L15.1,3.9
			z M16.7,17h-6.5v-1.6h6.5V17z M16.7,13.7h-6.5v-1.6h6.5V13.7z M14.2,9.6V5.1l4.5,4.5H14.2z"/>
		<g>
			<path fill="#3F3F3F" d="M37.1,8.5c-0.1,0.1-0.3,0.4-0.3,0.6c-0.4,1-1.1,2.3-2,3.4c1.2,1.1,2.7,2.6,3.4,3.5L37.2,17
				c-0.8-1.1-2-2.4-3.2-3.5c-1.3,1.4-2.9,2.7-4.6,3.4l-1-1c1.9-0.7,3.7-2.2,4.9-3.5c0.8-0.9,1.6-2.2,1.9-3.2h-4.4
				c-0.5,0-1.1,0.1-1.3,0.1V7.9C29.8,8,30.5,8,30.9,8h4.4c0.4,0,0.8,0,1-0.1L37.1,8.5z"/>
			<path fill="#3F3F3F" d="M49.7,10.8c-0.1,0.1-0.2,0.3-0.2,0.4c-0.3,1.2-0.9,2.4-1.8,3.4c-1.2,1.4-2.8,2.1-4.3,2.6l-0.9-1.1
				c1.7-0.4,3.2-1.1,4.2-2.2c0.7-0.7,1.1-1.6,1.3-2.4H42c-0.3,0-0.8,0-1.3,0v-1.2c0.5,0,0.9,0.1,1.3,0.1h6.1c0.3,0,0.6,0,0.8-0.1
				L49.7,10.8z M41.8,7.5c0.3,0,0.8,0.1,1.1,0.1h4.7c0.4,0,0.9,0,1.2-0.1v1.2c-0.3,0-0.8,0-1.2,0H43c-0.4,0-0.8,0-1.1,0V7.5z"/>
			<path fill="#3F3F3F" d="M58.4,15.6c0,0.5,0,1.2,0.1,1.4h-1.5c0-0.3,0.1-0.9,0.1-1.4v-4.3c-1.3,0.7-2.9,1.3-4.3,1.8L52,11.9
				c2.1-0.5,4.1-1.4,5.4-2.2C58.6,9,59.9,7.9,60.5,7l1,0.9c-0.9,0.9-2,1.8-3.2,2.6V15.6z"/>
			<path fill="#3F3F3F" d="M66.7,10.5c1.6,0.5,3.9,1.3,5.1,1.9l-0.5,1.3c-1.3-0.7-3.2-1.4-4.5-1.9l0,3.7c0,0.4,0,1.1,0.1,1.5h-1.5
				c0.1-0.4,0.1-1.1,0.1-1.5V8.7c0-0.4,0-0.9-0.1-1.3h1.5c0,0.4-0.1,0.9-0.1,1.3V10.5z M70.2,10c-0.3-0.7-0.6-1.3-1.1-1.8l0.8-0.3
				C70.2,8.3,70.7,9,71,9.6L70.2,10z M71.7,9.3c-0.3-0.7-0.7-1.2-1.1-1.8l0.8-0.4c0.3,0.4,0.8,1.2,1.1,1.8L71.7,9.3z"/>
		</g>
		</svg>
    );
}
